<template>
  <mv-page>
    <v-flex slot="header" xs12 hidden-sm-and-down>
    </v-flex>
    <mv-default-row>
      <v-layout row wrap>
        <v-flex xs12 sm12 md4 lg4>
          <h2 class="font-weight-light">Восстановление пароля</h2>
          <v-form ref="form">
            <v-text-field
              autocomplete
              name="login"
              v-model="cardid"
              type="text"
              label="школьная карта"
              required
              outline
              append-icon="credit_card"
              @keyup.enter="$refs.email.focus"
            ></v-text-field>
            <v-text-field
              autocomplete
              ref="email"
              name="email"
              v-model="email"
              type="email"
              label="email"
              required
              outline
              append-icon="alternate_email"
              @keyup.enter="restorepassword"
            ></v-text-field>
            <v-btn outline block large color="primary" @click.native.stop="restorepassword" :disabled="!valid">Продолжить</v-btn>
          </v-form>
        </v-flex>
        <v-flex d-flex sm12 md1></v-flex>
        <v-flex sm12 md7 lg7 d-flex>
          <v-card light color="amber lighten-3" class="mb-1">
            <v-card-text>
              <p>
                Если вы ранее не регистрировались, то пройдите процедуру <a href='/#/signup'>регистрации.</a>
              </p>
              <br />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </mv-default-row>
  </mv-page>
</template>
<script>
// eslint-disable-next-line
const emailRe = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
export default {
  name: 'restore-password',
  data: () => ({
    email: null,
    cardid: null
  }),
  computed: {
    valid () {
      if (!this.email) return false
      if (!this.cardid) return false
      if (this.cardid.length < 6) return false
      if (!emailRe.test(this.email)) return false
      return true
    }
  },
  methods: {
    async restorepassword () {
      try {
        if (!this.valid) return
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'auth-reset-password',
          pl: {
            email: this.email,
            cardid: ('000' + this.cardid).slice(-9)
          }
        })
        this.$store.dispatch('snack', meta.msg)
        this.$router.push('login')
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
  }
}
</script>
